export const SUBJECT_CONTRACT = 'Usuário contrata plano';
export const EMAIL_TEAM = 'blipgocore@blip.ai';
export const SEND_TO = 'AW-874108198/km2kCJXJn5wYEKaq56AD';
export const SUBJECT_CONNECTION_CHOICE = 'Usuário escolhe forma de ativação';
